import "./AlreadyTook.css";
import Course from "./Course.js";
import PropTypes from "prop-types";

function AlreadyTook(props) {
  return (
    <div className="dashboard">
      <h2 className="dashboard-title">Already Took</h2>
      <div className="dashboard-courses">
        <ol className="courses-grid">
          {props.courses.map(course => (
            <Course
              course={course}
              key={course._id}
              updateCourse={props.updateCourse}
              removeCourse={props.removeCourse}
            />
          ))}
        </ol>
      </div>
    </div>
  );
}

export default AlreadyTook;

AlreadyTook.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string,
      title: PropTypes.string,
      term: PropTypes.string,
      status: PropTypes.string,
      _id: PropTypes.string,
      color: PropTypes.string,
    })
  ),
  updateCourse: PropTypes.func.isRequired,
  removeCourse: PropTypes.func.isRequired,
}
